import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRejected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.75 0C0.335786 0 0 0.335786 0 0.75V9.75V17H1.5V10.5H15.25C15.5157 10.5 15.7616 10.3594 15.8964 10.1303C16.0312 9.90131 16.0347 9.61807 15.9056 9.38577L13.608 5.25L15.9056 1.11423C16.0347 0.881934 16.0312 0.598688 15.8964 0.369654C15.7616 0.140621 15.5157 0 15.25 0H0.75ZM13.9754 9H1.5V1.5H13.9754L12.0944 4.88577C11.9685 5.11228 11.9685 5.38772 12.0944 5.61423L13.9754 9ZM4.64645 3.35355L6.5429 5.25L4.64645 7.14645L5.35356 7.85355L7.25 5.95711L9.14645 7.85355L9.85356 7.14645L7.95711 5.25L9.85356 3.35355L9.14645 2.64645L7.25 4.54289L5.35356 2.64645L4.64645 3.35355Z"
	})
});
export default SvgRejected;
